import "./Footer.css"

export default function Footer() {
    return (
        <div className='footer' style={{ backgroundColor: 'rgba(250, 250, 252, 0.137)' }}
>
            <div className="row">
                <div className="col-md-5 footer-desc">
                    <h3>AgentShades</h3>
                    <p>AgentShades is a user-friendly website builder designed specifically for real estate agents, offering a range of customizable templates tailored to showcase properties effectively. With intuitive tools and seamless integration of property listings, AgentShades empowers agents to create stunning websites that attract and engage potential clients.</p>
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-5">
                    <div className="row footer-site-map">
                        <div className="col-md-4">
                            <h5>Solutions</h5>
                            <ul>
                                <li>Real Estate Websites</li>
                                <li>IDX Home Search</li>
                                <li>Property Websites</li>
                                <li>Digital CMA</li>
                                <li>Referral Network</li>
                                <li>Brokerage Solutions</li>
                            </ul>

                        </div>
                        <div className="col-md-4">
                            <h5>Services</h5>
                            <ul>
                                <li>SEO</li>
                                <li>Content Marketing</li>
                                <li>Advertising</li>
                                <li>Social Media</li>
                            </ul>

                        </div>
                        <div className="col-md-4">
                            <h5>Explore</h5>
                            <ul>
                                <li>Designs</li>
                                <li>Marketing Platform</li>
                                <li>Case Studies</li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className='footer-copyright'>
                <p>© 2023 Copyright AgentShades</p>
            </div>

        </div>
    )
}
